import React from "react";
import { Descriptions } from "antd";
import moment from "moment";
import { formatPrice, formatDistance } from "@/utils/utils";
import VehiclesSummaryList from "./VehiclesSummaryList";

const ShipmentRequirementsSummaryItem = ({ shipmentData }) => {
  const { distance, pickupAddress, dropOffAddress, transporterPricePerMile, totalTransporterPrice } = shipmentData;

  return (
    <>
      <Descriptions style={{ marginTop: 16 }} layout="horizontal">
        <Descriptions.Item label="Total Price">{formatPrice(totalTransporterPrice)}</Descriptions.Item>
        <Descriptions.Item label="Price Per Mile">{formatPrice(transporterPricePerMile)}</Descriptions.Item>
        <Descriptions.Item label="Distance">{`${formatDistance(distance)} miles`}</Descriptions.Item>
      </Descriptions>
      <Descriptions style={{ marginTop: 16 }} layout="vertical">
        <Descriptions.Item label="Pickup Address">
          {`${pickupAddress.simplifyAddress}, ${pickupAddress.zipCode}` ?? "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Pickup Instructions">
          {pickupAddress.notes ? pickupAddress.notes : "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="Availability">
          {shipmentData?.availableNow
            ? "Available Now"
            : shipmentData?.availableAt
            ? moment.utc(shipmentData?.availableAt).local().format("M/D/YY")
            : ""}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions style={{ marginTop: 16 }} layout="vertical">
        <Descriptions.Item label="DropOff Address">
          {`${dropOffAddress.simplifyAddress}, ${dropOffAddress.zipCode}` ?? "N/A"}
        </Descriptions.Item>
        <Descriptions.Item label="DropOff Instructions">
          {dropOffAddress.notes ? dropOffAddress.notes : "N/A"}
        </Descriptions.Item>
      </Descriptions>
      <VehiclesSummaryList shipment={shipmentData} />
    </>
  );
};

export default ShipmentRequirementsSummaryItem;
